
import React, { Component } from 'react';
import { C } from '../../constants';

import AppHeaderCorona from './AppHeaderCorona';
import AppHeaderRZD from './AppHeaderRZD';

class AppHeader extends Component {
  getHeader = () => {
    let header;
    switch (C.PRODUCT) {
      case "RZD":
        header = <AppHeaderRZD />;
        break;

      case "RZD_EMPL":
        header = <AppHeaderRZD />;
        break;

      default:
        header = <AppHeaderCorona />;
        break;
    }

    return header;
  }

  render() {
    return this.getHeader();
  }
}

export default AppHeader;